import {createApp} from 'vue'
import '@/styles/app.css'
import App from '@/App.vue'

import {createAppRouter} from '@/router'
import {createPinia} from 'pinia'
import axios from "axios";
import i18n from "@/i18n";
import ROUTES from '@/config/ROUTES.ts'
import VueGtag from 'vue-gtag'

const pinia = createPinia()

const router = await createAppRouter(pinia)

const app = createApp(App)
    .use(router)
    .use(pinia)
    .use(i18n)

app.config.globalProperties.$routes = ROUTES

const gtag = import.meta.env.VITE_APP_GTAG_ID
if (gtag) {
    app.use(VueGtag, {
        bootstrap: false,
        config: {id: gtag},
    }, router)
}

try {
    const {data} = await axios.get(`${window.location.origin}/icons.svg`)
    document.body.insertAdjacentHTML('afterbegin', data)
} catch {
}

app.mount('#app')